import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Box, CircularProgress, Typography } from "@mui/material";

/**
 * Links antigos no formato /share.php?id=... (antes usavam replaceState na página do produto).
 * No dev server o public/share.php era servido como arquivo bruto (PHP não executado) e o
 * navegador baixava o arquivo. Redireciona para /produto/:id dentro do SPA.
 *
 * Nota: Open Graph para redes sociais em ambiente só React costuma exigir SSR ou
 * uma página estática no servidor; este redirect resolve só a navegação no app.
 */
export default function SharePhpRedirect() {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    useEffect(() => {
        const id = searchParams.get("id");
        if (id) {
            navigate(`/produto/${encodeURIComponent(id)}`, { replace: true });
        } else {
            navigate("/produtos", { replace: true });
        }
    }, [searchParams, navigate]);

    return (
        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", py: 8, gap: 2 }}>
            <CircularProgress size={32} />
            <Typography variant="body2" color="text.secondary">
                Redirecionando…
            </Typography>
        </Box>
    );
}
